module.exports = __webpack_public_path__ + "assets/fail-rosette.59d04f5f.svg";